import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import StatusScreenWrapper from "../components/StatusScreenWrapper";
import MainTitle from "../components/MainTitle";



const PaymentSuccess = () => {

    const location = useLocation();

    const navigate = useNavigate();

    const [renderResult, setRenderResult] = useState(false);

    // Esta función te ayuda a extraer los parámetros de la URL
    const getQueryParams = (search) => {
        return new URLSearchParams(search);
    };

    const queryParams = getQueryParams(location.search);

    // Ejemplo de cómo obtener algunos parámetros
    // const collectionId = queryParams.get("collection_id");
    const paymentId = queryParams.get("payment_id");
    console.log("Payment ID", paymentId);
    // const status = queryParams.get("status");
    // const externalReference = queryParams.get("external_reference");

    return (
        <div className="min-h-screen bg-[#f7f4ef] pb-10">

            {/* Header */}
            <MainTitle />

            {/* Comprobante de Mercado Pago */}
            <StatusScreenWrapper payment_id={paymentId} setRenderResult={setRenderResult}/>

            {renderResult && (
                <div className="px-4 mt-4">
                    <button
                        onClick={() => navigate(`/purchase/success/${paymentId}`)}
                        className="w-full py-3 rounded-xl text-sm font-semibold bg-[#8c1d2f] hover:bg-[#a82a42] active:scale-[0.98] text-[#f5f0e8] shadow-md shadow-[#8c1d2f]/20 transition-all duration-150"
                    >
                        Continuar →
                    </button>
                </div>
            )}
        </div>
    );
}

export default PaymentSuccess;
